// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton___kiMg","skeleton-animation":"styles_skeleton-animation__PiXed","button":"styles_button__wUYAk"};